/** @jsxImportSource @emotion/react */
import { Typography } from '@mui/material'
import { format } from 'date-fns'

import { findAllAiTestTrainingData_findAllAiTestTrainingData_items as TrainingData } from '__generatedTypes__/findAllAiTestTrainingData'
import { AITestTypeEnum } from '__generatedTypes__/globalTypes'
import * as classes from './styles'

const typeLabelMap = {
  [AITestTypeEnum.TextTest]: 'Text Response',
  [AITestTypeEnum.VideoTest]: 'Video Response',
}

type Props = {
  data: TrainingData
}

export const Details = ({ data }: Props) => (
  <div css={classes.wrapper}>
    <div css={classes.detail}>
      <Typography css={classes.name}>Email:</Typography>
      <Typography css={classes.value}>{data.userEmail}</Typography>
    </div>

    <div css={classes.detail}>
      <Typography css={classes.name}>Date:</Typography>
      <Typography css={classes.value}>{format(new Date(data.createdAt), 'dd.MM.yy')}</Typography>
    </div>

    <div css={classes.detail}>
      <Typography css={classes.name}>Time:</Typography>
      <Typography css={classes.value}>{format(new Date(data.createdAt), 'HH:mm')}</Typography>
    </div>

    <div css={classes.detail}>
      <Typography css={classes.name}>Type of Test:</Typography>
      <Typography css={classes.value}>{typeLabelMap[data.testType]}</Typography>
    </div>
  </div>
)
